import { Protection, UrlType } from "@sportal/api";
import { EULA_CANCEL_STRATEGY } from "../../pages/login/components";

export interface Language {
  key: string;
  name: string;
  inversedDirection?: boolean;
}

interface Languages {
  default: string;
  list: Language[];
}

interface Protections {
  [Protection.None]?: boolean;
  [Protection.Light]?: boolean;
  [Protection.Medium]?: boolean;
  [Protection.Strict]?: boolean;
}

interface SafeSearchServices {
  google?: boolean;
  youtube?: boolean;
  bing?: boolean;
}

export interface GroupDefaults {
  visitors: {
    protection: Protection;
    "safe-search-services": SafeSearchServices;
    "subscriber-safety"?: boolean;
  };
  employees: {
    protection: Protection;
    "safe-search-services": SafeSearchServices;
    "subscriber-safety"?: boolean;
  };
  custom: {
    protection: Protection;
    "safe-search-services": SafeSearchServices;
    "subscriber-safety"?: boolean;
  };
}

interface Security {
  noLoginPage?: boolean;
  goBackOnLoginErrorLinkText?: string;
  goBackOnLoginErrorLink?: string;
  logoutUrl: string;
  responseCodeHeader: string;
  urlParamsForSubscriberData: string[];
}

export enum Weekdays {
  Monday = "MO",
  Tuesday = "TU",
  Wednesday = "WE",
  Thursday = "TH",
  Friday = "FR",
  Saturday = "SA",
  Sunday = "SU",
}

export interface ExternalLink {
  isExternal: boolean;
  url: string;
}

export interface UrlFilters {
  "url-types": UrlType[];
}

// We might further organize this interface by creating other types like:
// * UserAppConfig - values that are exposed to the end customer
// * InternalAppConfig - our custom values like "emailRegex"

export interface AppConfig {
  emailRegex: string;
  backendUrl: string;
  logoLink: string | ExternalLink;
  languages: Languages;
  protections: Protections;
  groupDefaults: GroupDefaults;
  urlFilters: UrlFilters;
  useFallbackLanguage?: boolean;
  security: Security;
  appTitle: string;
  sessionExpiryURL: string;
  secureBlocksLimit: number;
  secureBlocksLimitCsv: number;
  customLinkRef: string;
  showErrorPageBeforeAutoLogout?: boolean;
  firstDayOfWeek: Weekdays;
  helpPageLink: string | ExternalLink;
  footerCompanyLink: string | ExternalLink;
  showScheduledReports?: boolean;
  showDrilldownPeriod?: boolean;
  showEulaHeader?: boolean;
  showEulaFooter?: boolean;
  showEulaDialog?: boolean;
  eulaCancelStrategy: EULA_CANCEL_STRATEGY;
  eulaCancelRedirectUrl: string;
  footerIcons: [];
  footerPhoneNumbers: [];
  footerSupportLink: string | ExternalLink;
  loginLink: string;
  reportingTimeoutMinutes?: number;
}
